import * as TYPES from './types';
export default {
    [TYPES.SET_HISTORYS](payload = {}) {
        this.historys = payload
    },
    [TYPES.SET_SOURCE](payload = []) {
        this.source = payload
    },

    [TYPES.GET_HISTORYS](payload = {}) {
        let { info, isSold } = payload;
        return this.axiosIns.get(
            // `/data-api/listing/${info.id}/update?status=${info.listingStatus}&listingType=${listingType}`
            `/api-site/data-api/listing/v2/${info.id}/update?isSold=${isSold}&mlsOrgId=${info.mlsOrgId}&mlsListingId=${info.mlsListingId}`
        );
    },
    [TYPES.GET_MLS](mlsOrgId) {
        return this.axiosIns
            .post('/api-graphql', {
                query: `{mls(id:${mlsOrgId}){id,name}}`
            }).then(res => {
                let mls = res && res.data && res.data.mls;
                return mls?.name;
            });
    }
}